import React, { useEffect, useState } from 'react';
import HeaderStyleThree from '../../components/Layout/Header/HeaderStyleThree';
import Footer from '../../components/Layout/Footer';
import BackToTop from '../../components/elements/BackToTop';
import TrainingsHero from './TrainingsHero';
import TrainingsMain from './TrainingsMain';

const TrainingsPage = () => {
    const [isVisible, setIsVisible] = useState(false);
    useEffect(() => {
        const h = () => setIsVisible(window.scrollY > 300);
        document.addEventListener('scroll', h);
        return () => document.removeEventListener('scroll', h);
    }, []);
    return (
        <div className="homestyle2">
            <HeaderStyleThree />
            <TrainingsHero />
            <TrainingsMain />
            <BackToTop scroll={isVisible} />
            <Footer />
        </div>
    );
};
export default TrainingsPage;
